import React, { useState } from "react";
import { Button, Form, Input } from "antd";
import "antd/dist/reset.css"; // Import Ant Design styles
import { message } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const onFinish = async (values) => {
    const { username, password } = values;
    // Basic Validation
    if (!username || !password) {
      setErrorMessage("Please fill in all fields.");
    } else {
      setErrorMessage("");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
          {
            identifier: username,
            password: password,
          }
        );
        const authToken = response.headers.get("authorization");
        if (authToken) {
          Cookies.set("authToken", authToken, {
            expires: 30, // Cookie expires in 30 days
            secure: true, // Ensures the cookie is only sent over HTTPS
            sameSite: "Strict", // Only sent with same-site requests
          });
        } else {
          console.log("Authorization header not found.");
        }

        if (response.status === 200) {
          let data = response?.data;
          localStorage.setItem("username", data?.data?.user.userName);
          localStorage.setItem("role", data?.data?.user.role);
          message.success("Login successful");
          navigate("/dashboard");
        }
      } catch (error) {
        message.error(
          error?.response?.data?.message || "Something went wrong in login."
        );
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    setErrorMessage("Please fill in all fields.");
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <Form
          name="loginForm"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          className="login-form"
        >
          <h2 style={{ textAlign: "center", color: "#ff7d4d" }}>Login</h2>
          <Form.Item
            // label="Username"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input placeholder="Username" />
          </Form.Item>

          <Form.Item
            // label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          {errorMessage && <p className="error-message">{errorMessage}</p>}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              style={{ backgroundColor: "#ff7d4d" }}
            >
              Sign in
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AdminLogin;
